export const iOSSpringAnimation = {
  type: 'spring',
  stiffness: 200,
  bounce: 0.25,
  damping: 22,
  mass: 1,
}
